/**
 * One direction, everything about it in one place (owner, 2026-10-12: one menu of five sections instead of
 * fourteen tabs; "Напрями › Ігри" with its statistics, accounts, posts and links behind tabs). The tabs are
 * the pages that already exist, narrowed to this direction — nothing is shown twice in two ways.
 */

import { useParams, useSearchParams } from 'react-router-dom'

import { useT } from '../../i18n'
import { Chips } from '../../ui/components'
import { Dashboard } from '../dashboard/Dashboard'
import { Crumbs } from '../layout/Section'
import { AccountsPanel } from './AccountsPanel'
import { DirectionChip, useDirectionName, useDirections } from './directions'
import { DirectionPhones } from './DirectionsPanel'
import { LinksPanel } from './LinksPanel'
import { PublicationsPanel } from './PublicationsPanel'

type Tab = 'stats' | 'accounts' | 'posts' | 'links' | 'phones'
const TABS: Tab[] = ['stats', 'accounts', 'posts', 'links', 'phones']

export function DirectionPage() {
  const t = useT()
  const m = t.direction
  const { id = '' } = useParams()
  const [params, setParams] = useSearchParams()
  const tab = (TABS.includes(params.get('tab') as Tab) ? params.get('tab') : 'stats') as Tab
  const dirs = useDirections()
  const nameOf = useDirectionName()
  const dir = dirs.byId.get(id)
  const go = (next: Tab) => {
    const p = new URLSearchParams()
    if (next !== 'stats') p.set('tab', next)
    setParams(p)
  }
  return (
    <div className="page col">
      <Crumbs items={[{ label: t.sections.directions, to: '/directions' }, { label: dir ? nameOf(dir) : id }]} />
      <div className="direction-head">
        {dir && <DirectionChip direction={dir} />}
        {dir && <span className="tiny dim">{t.dirs.counts(dir.phones ?? 0, dir.accounts ?? 0)}</span>}
        {dirs.data && !dir && <span className="warn-text">{m.unknown}</span>}
      </div>
      <Chips<Tab> value={tab} onChange={go} options={TABS.map((x) => ({ id: x, label: m.tabs[x] }))} />
      {tab === 'stats' && <Dashboard direction={id} />}
      {tab === 'accounts' && <AccountsPanel direction={id} />}
      {tab === 'posts' && <PublicationsPanel direction={id} />}
      {tab === 'links' && <LinksPanel direction={id} />}
      {tab === 'phones' && dir && <DirectionPhones direction={dir} />}
    </div>
  )
}
